export default __webpack_public_path__ + "assets/webgl/intro_blank.977646b3.png";